// extracted by mini-css-extract-plugin
export default {"aside":"src-modules-form-LabelHelper-style__aside_eeHsY","inline":"src-modules-form-LabelHelper-style__inline_bAlzS"};